import { render, staticRenderFns } from "./GeneralDataProtectionRegulation.vue?vue&type=template&id=01f4ddec&scoped=true"
import script from "./GeneralDataProtectionRegulation.vue?vue&type=script&lang=js"
export * from "./GeneralDataProtectionRegulation.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataProtectionRegulation.vue?vue&type=style&index=0&id=01f4ddec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4ddec",
  null
  
)

export default component.exports